export enum MESSAGE_STRUCTURE_TYPE {
    Bubble = "bubble",
    Card = "card",
    Modal = "modal",
    Time = "time",
    FetchMsg = "fetch_msg"
}